import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { clsx } from 'clsx';
const IMAGES = [{
  url: 'https://cdn.magicpatterns.com/uploads/9GBFjYbnMMyVSj2j7PT1Nc/ChatGPT_Image_Jun_21,_2026,_10_42_52_PM.png',
  alt: 'Libro Cómo Conectar con Tu Bebé Antes de Nacer sobre sábanas blancas con un café'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/w5NAmYRD8PxtoUtJXQWRAS/ChatGPT_Image_Jun_21,_2026,_10_43_00_PM.png',
  alt: 'Libro de pie sobre una mesa de madera con decoración cálida'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/rthX6ajas2QRfLt1fdjb8r/ChatGPT_Image_Jun_21,_2026,_10_43_17_PM.png',
  alt: 'Mujer embarazada leyendo el libro en el sofá'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/wzR8d9QbJG4MxuhzGF8mTp/ChatGPT_Image_Jun_21,_2026,_10_43_10_PM.png',
  alt: 'Mamá leyendo el libro junto a su hijo pequeño'
}];
export function ProductGallery() {
  const [activeIndex, setActiveIndex] = useState(0);
  return <div className="flex flex-col gap-4 w-full" data-id="element-69">
      {/* Main Image */}
      <div className="relative aspect-[4/5] md:aspect-square w-full overflow-hidden rounded-2xl bg-brand-cream-alt border border-brand-gold/20 shadow-sm" data-id="element-70">
        <AnimatePresence mode="wait" data-id="element-71">
          <motion.img key={activeIndex} src={IMAGES[activeIndex].url} alt={IMAGES[activeIndex].alt} initial={{
          opacity: 0,
          scale: 1.02
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.4,
          ease: 'easeInOut'
        }} className="absolute inset-0 w-full h-full object-cover" data-id="element-72" />
        </AnimatePresence>
      </div>

      {/* Thumbnails */}
      <div className="grid grid-cols-4 gap-3" data-id="element-73">
        {IMAGES.map((img, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={clsx('relative aspect-square overflow-hidden rounded-xl border-2 transition-all duration-200', activeIndex === idx ? 'border-brand-burgundy shadow-md scale-[1.02]' : 'border-transparent hover:border-brand-rose-light/50 opacity-70 hover:opacity-100')} aria-label={`Ver imagen ${idx + 1}`} aria-current={activeIndex === idx} data-id="element-74">
            <img src={img.url} alt={`Miniatura ${idx + 1}`} className="w-full h-full object-cover" data-id="element-75" />
          </button>)}
      </div>
    </div>;
}